// Versão compilada no bundle pelo CRA (script `build` exporta
// REACT_APP_BUILD_TIMESTAMP=$(date +%s)). Em `npm run dev` fica "" e o gate
// desliga sozinho.
export const BUNDLE_VERSION = String(process.env.REACT_APP_BUILD_TIMESTAMP || "");

export function isBundleOutdated(bundleVersion, serverVersion) {
  const local = bundleVersion == null ? "" : String(bundleVersion);
  const remote = serverVersion == null ? "" : String(serverVersion);
  if (!local || !remote) return false;
  return local !== remote;
}

/**
 * Lê /version.json (gravado pelo scripts/inject-version.js no build) sem
 * cache. Devolve "" em qualquer falha — o chamador não deve alertar.
 */
export async function fetchServerBundleVersion() {
  if (!BUNDLE_VERSION) return "";
  try {
    const res = await fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return "";
    const data = await res.json();
    return data && data.version != null ? String(data.version) : "";
  } catch (e) {
    return "";
  }
}
